<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0">

    <cropper [avatar]="''" [page]="'picture'" [defaultRatio]="true" (sendImg)="setImg($event)"></cropper>

  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

    @if (action !=='edit') {
      <button
        mat-raised-button
        (click)="dialogRef.close(uploadedImg)"
        class="save-button mat-accent"
        [disabled]="!uploadedImg"
        aria-label="SAVE">
        {{'main.save' | translate}}
      </button>
    }
  </div>
</div>
